import { useAtom } from "jotai";
import React, { Suspense, useEffect, useRef, useState } from "react";
import withLayout from "../../../src/layouts/withLayout";
import Introduction from "@Components/movie/Details/Introduction";
import Share from "@Components/movie/Details/Share";
import Headline from "@Components/movie/Details/Headline";
import VPlayer from "@Components/movie/Shorts/vplayer";
import styled from "styled-components";

import { article, movie } from "@Api";
import { Breadcrumb, Skeleton, Switch } from "antd";
import qs from "qs";
import { host } from "@Services/url";
import { useLocalStorageState } from "ahooks";
import { initTracking } from "@Lib/jotai/tracking";

import { CaretRightOutlined } from "@ant-design/icons";
import { fetchGetMovieDetail } from "@Services/movie";
import DetailsAdvertisement, { useAdvertisementShow } from "@Components/movie/Details/Ad";


const MoviesShort = React.lazy(() => import("@Components/movie/MoviesShort"));
const AffixRelevantKinds = React.lazy(() => import("@Components/movie/AffixRelevantKinds"));
const ArticleList = React.lazy(() => import("@Components/movie/Details/ArticleList"));
// const NewComment = React.lazy(() => import("@Components/movie/Details/Comment/newComment"));
const NewComment = React.lazy(() => import("@Components/movie/Details/Comment/NewComment/index"));


const BreadcrumbStyled = styled(Breadcrumb)`
  .ant-breadcrumb-separator {
    color: #fff;
    margin: 0 8px;
  }
`;

const {
  fetchShortsDetail,
  fetchShortMovieList,
  fetchArticleMovieRead,
  fetchShortsKindsRecommend,
  fetchShortsArticleRecommend,
} = movie;
const { fetchEquipMovieLikeStatus, fetchCommentAdd } = article;
type TMovies = {};

let stayTime: any = null;
let videoTarget: any = null;

interface IVideo {
  bring: { [key: string]: any };
  collection: { [key: string]: any };
  info: { [key: string]: any };
  kinds: any[];
  status: { [key: string]: any };
  user: { [key: string]: any };
}

interface IListItems {
  comments: number;
  downloadLink: string;
  favorite: number;
  id: number;
  kolId: number;
  likes: number;
  mId: number;
  playTime: number;
  share: number;
  shareLink: string;
  thumb: string;
  title: string;
  videoLink: string;
  views: number;
}
interface IColumnsTotal {
  authors: {
    kolId: number;
    link: string;
    name: string;
    thumb: string;
  }[];
  description: string;
  icon: string;
  label: string;
  lastUpdateTime: string;
  presenter: {
    kolId: number;
    link: string;
    name: string;
    thumb: string;
  }[];
  shorts: number;
  title: string;
  total: number;
}

const ShortsDetail: React.FC<TMovies> = ({ }) => {
  const { c } = host;
  const params = qs.parse(location.search, { ignoreQueryPrefix: true });
  const [playShortStatus, setPlayShortStatus] = useLocalStorageState("playShort_status", {
    defaultValue: true,
  });
  const getHeightRef = useRef(null);
  const playerRef = useRef<any>(null);
  const [movieInfo, setMovieInfo] = useState<IVideo>();
  const [shortsList, setShortsList] = useState<IListItems[]>([]);
  const [nextAutoPlay, setNextAutoPlay] = useState(false);

  const [showFlag, updateAdData] = useAdvertisementShow();
  const [tracking] = useAtom(initTracking);
  const [likedState, setLikedState] = useState({
    static: {
      likes: 0,
      unlikes: 0,
    },
    status: {
      liked: 0,
      unliked: 0,
    },
  });
  const [columnsTotal, setColumnsTotal] = useState<IColumnsTotal>();

  const fetch = async (id = window.SHORTS_ID) => {
    try {
      const res: any = await fetchShortsDetail({ id });
      if (res?.status === 12000) {
        setMovieInfo(res.data);
        updateAdData({ data: res.data });
      }
    } catch (error) { }
  };

  const fetchList = async () => {
    try {
      const res: any = await fetchShortMovieList({
        categoryId: params.categoryId,
        type: "11",
        limit: params.categoryId ? 10 : 50,
      });

      if (res?.status === 12000) {
        setShortsList(res.data.items);
      }
    } catch (error) { }
  };

  const fetchLikeState = async (id = window.SHORTS_ID) => {
    try {
      const res: { data; status } = await fetchEquipMovieLikeStatus({ id, model: "shorts" });
      if (res.status === 12000) {
        setLikedState(res.data);
        fetch(id);
      }
    } catch (error) { }
  };

  const handleChildClick = (e) => {
    videoTarget = e;
    fetchArticleMovieRead({ type: "shorts", id: window.SHORTS_ID });
  };

  const onChange = (checked: boolean) => {
    setPlayShortStatus(checked);
  };

  const handleUnload = () => {
    if (stayTime) {
      const stayDuration = Date.now() - stayTime;
      const currentTime = videoTarget ? parseInt(videoTarget._currentTime) : 0;

      tracking &&
        tracking.trackEvent({
          name: "video_closed",
          params: {
            page_sub_business: "新車影音",
            page_business: "新車",
            trigger_id: "2851",
            page_id: "334",
            trigger_name: "PC短影音播放器",
            next_spm: "7.334.152.427",
            page: "短影音播放頁",
            channel: "影音",
            element_id: "PC短影音播放器",
            element: "按鈕",
            module: "播放頁",
            tracker_method: "config",
            progress_bar_duration: currentTime,
            timer_duration: Math.floor(stayDuration / 1000),
            object_id: window.SHORTS_ID || movieInfo?.info?.id || 0,
          },
        });

      stayTime = Date.now();
    }
  };

  const getUrlParameter = (param) => {
    const urlParams = new URLSearchParams(window.location.search);
    return Number(urlParams.get(param)) || 0;
  };

  const getNextVideoUrl = (currentIndex, shortsList, categoryId) => {
    const nextIndex = currentIndex + 1;
    const shortId = shortsList[currentIndex]?.id || shortsList[0]?.id;
    const categoryQuery = categoryId ? `&categoryId=${categoryId}` : "";

    return `/shorts/${shortId}?currentIndex=${nextIndex}${categoryQuery}`;
  };

  const setNextUrl = () => {
    const currentIndex = getUrlParameter("currentIndex");
    const nextShortUrl = getNextVideoUrl(currentIndex, shortsList, params.categoryId);
    return nextShortUrl ?? "";
  };

  const handleUpdateVideo = () => {
    const currentIndex = getUrlParameter("currentIndex");
    const shortId = shortsList[currentIndex]?.id || shortsList[0]?.id;
    Promise.all([fetchLikeState(shortId), fetch(shortId)]).then(() => {
      updateAdData({ currentTime: 0 });
      playerRef.current?.updatePlayer?.();
    });
  };

  const handleplayNext = () => {
    const url = setNextUrl();
    window.history.pushState("", "", url);
    handleUpdateVideo();
  };

  const getColumnsTotal = async () => {
    const params = {
      fields: "categoryInfo",
      key: movieInfo?.info?.slug,
      iconType: 1,
    };
    const res: any = await fetchGetMovieDetail(params);
    if (res && res.status === 12000) {
      setColumnsTotal(res.data.categoryInfo);
    }
  };

  useEffect(() => {
    fetchLikeState();
    fetchList();
  }, []);

  useEffect(() => {
    getColumnsTotal();
  }, [movieInfo?.info?.id]);

  useEffect(() => {
    if (nextAutoPlay && shortsList.length > 0 && playShortStatus) {
      handleplayNext();
    }
  }, [nextAutoPlay]);

  useEffect(() => {
    if (!tracking) return;
    // 当页面进入时记录开始时间
    stayTime = Date.now();
    window.addEventListener("beforeunload", () => handleUnload());
    return () => {
      window.removeEventListener("beforeunload", () => handleUnload());
    };
  }, [movieInfo?.info?.id]);


  return (
    <section>
      {!!movieInfo?.info?.id ? <div className="min-h-[700px] mx-auto mb-20" style={{ background: "radial-gradient(#43444c, #050a1a)" }}>
        <div className='pt-24 w-1190 m-auto'>
          <BreadcrumbStyled separator='>'>
            <Breadcrumb.Item>
              <span className='text-white'>影音合輯</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span className='text-white'>短影音詳請頁</span>
            </Breadcrumb.Item>
          </BreadcrumbStyled>
          <div className='mt-14'>
            <div className="w-[1190px] relative inline-block group" ref={getHeightRef} style={{ color: "fade(#224C96, 70 %)" }}>
              <div className='relative z-0' style={{ width: "1190px", height: "672px" }}>
                <VPlayer
                  ref={playerRef}
                  autoplay={false}
                  loop={false}
                  id='ShortsVideo'
                  url={movieInfo?.info?.videoLink}
                  playNextUrlList={setNextUrl() !== "" ? [setNextUrl()] : []}
                  onEnd={handleplayNext}
                  onPlay={(e) => {
                    handleChildClick(e);
                  }}
                  onTimeHandler={(timer) => {
                    updateAdData({ currentTime: timer });
                  }}
                  onPlayNext={handleplayNext}
                >
                  <DetailsAdvertisement bring={movieInfo.bring as any} showFlag={showFlag} />
                </VPlayer>
              </div>
              <Introduction data={movieInfo.info} onChange={() => { }} />
              <div
                style={{ transition: "0.5s ease-in-out" }}
                className="
                  w-0
                  h-[150px]
                  opacity-0
                  invisible
                  absolute left-0 top-[20%] text-center z-[9]
                  group-hover:w-[66px]
                  group-hover:opacity-100
                  group-hover:visible
                ">
                <Share data={movieInfo.info} status='1' />
              </div>
              <div className="w-[1190px] inline-block relative">
                <Headline
                  id={window.SHORTS_ID}
                  model={"shorts"}
                  messageIcon={false}
                  data={{
                    ...movieInfo.info,
                    likes: likedState.static.likes,
                    unlikes: likedState.static.unlikes,
                    like_status: likedState.status.liked,
                    unlike_status: likedState.status.unliked,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div> : <Skeleton active className="min-h-[700px]" />}


      <Suspense fallback={<Skeleton active className="min-h-[700px]" />}>
        <div className='flex flex-col w-1190 m-auto'>
          <div className='flex justify-between'>
            <h2 className='text-20 leading-30 font-medium'>更多短影音</h2>
            <div className='text-12 text-[#999999] flex items-center justify-center'>
              <span className='mr-8'>連續播放</span>
              <Switch defaultChecked onChange={onChange} />
            </div>
          </div>

          <div className='flex justify-between'>
            <div className='w-886'>
              {shortsList.length > 0 && (
                <MoviesShort
                  dataSource={shortsList}
                  urlParams={params.categoryId ? `?categoryId=${params.categoryId}` : ""}
                  itemCss={"mb-40 w-282"}
                  imgBoxCss={"w-282 h-374"}
                />
              )}
            </div>

            <div className='w-280 flex flex-col pt-16'>
              {!!columnsTotal?.total && (
                <a
                  id='ColumnsTypeBox'
                  href={decodeURIComponent(encodeURIComponent(`${c}/movie/category/${columnsTotal?.title}`))}
                  style={{ background: "linear-gradient(to right, #4E4E4E, #050A1A)" }}
                  className='w-280 h-70 flex justify-between items-center px-16 mb-20 rounded-4'
                >
                  <img src={columnsTotal?.icon} alt='' className='w-100 h-48 object-cover' />
                  <p className='border-1 border-[#979797] border-solid rounded-16 flex justify-center items-center px-6 text-14 text-white'>
                    共{columnsTotal?.total}支
                    <CaretRightOutlined style={{ color: "#fff", fontSize: "10px" }} />
                  </p>
                </a>
              )}

              {!!movieInfo?.kinds.length && (
                <AffixRelevantKinds
                  offsetTop={118}
                  title=''
                  gaId={"ShortsDetail"}
                  source={"短影音播放頁"}
                  itemKey={"kindInfos"}
                  request={fetchShortsKindsRecommend}
                  params={{
                    kindids: movieInfo?.kinds.map((item) => item.kindId).join(","),
                  }}
                />
              )}
            </div>
          </div>

          <div className='w-886'>
            <div id='ShortsDetailArticleList'>
              <ArticleList
                request={fetchShortsArticleRecommend}
                params={{
                  kindId: movieInfo?.kinds.map((item) => item.kindId).join(","),
                }}
                info={{
                  data: {
                    kind_id: !!movieInfo?.kinds.length ? movieInfo?.kinds[0].kindId : "0",
                  },
                  kinds: movieInfo?.kinds,
                }}
                category='影音詳細頁'
              />
            </div>
            {/* <Comment id={movieInfo?.info?.id || 0} /> */}
            {!!movieInfo?.info?.id && <NewComment
              id={movieInfo?.info?.id || 0}
              sendCommentApi={fetchCommentAdd}
              pageType="shorts"
            />}
          </div>
        </div>
      </Suspense>
    </section>
  );
};
withLayout({
  cmp: <ShortsDetail />,
  params: {
    AdTopBanner: true,
    nav: "DefaultFixedNav",
    footer: "Footer",
  },
});
